import { useTranslation } from 'react-i18next'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import SearchIcon from '@mui/icons-material/Search'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import DownloadingIcon from '@mui/icons-material/Downloading'
import { useLocation } from 'react-router-dom'
import { userReportType } from '../constant'
import Select from 'react-dropdown-select'
import { useEffect } from 'react'

export const UserReportFilters = ({ data, methods }) => {
    const activeListOptions = [
        { name: 'Active', value: 'Active' },
        { name: 'InActive', value: 'InActive' },
    ]
    const weekListOptions = [
        { name: 'Week', value: 'WEEK' },
        { name: 'Month', value: 'MONTH' },
        { name: 'Year', value: 'YEAR' },
    ]
    const { t } = useTranslation()
    const { filterInputs } = data
    const { handleFilterInputChange, reset, search, getUserReport } = methods
    const btnClass = 'custom_button bg-green-color white-color ms-3 d-flex justify-content-around align-items-center'
    const location = useLocation()
    const pathSegments = location.pathname.split('/').filter(Boolean)
    const lastSegment = pathSegments[pathSegments.length - 1]

    useEffect(() => {
        if (lastSegment === userReportType[1]) {
            filterInputs.filter = { name: 'Active', value: 'Active' }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastSegment])

    return (
        <div className="row mt-2 w-100">
            <div className="col-md-2 col-sm-6 col-12">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={'Start Date'}
                        value={filterInputs?.startDate || null}
                        onChange={(newValue) => handleFilterInputChange('startDate', newValue)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                    />
                </LocalizationProvider>
            </div>
            <div className="col-md-2 col-sm-6 col-12">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={'End Date'}
                        value={filterInputs?.endDate || null}
                        onChange={(newValue) => handleFilterInputChange('endDate', newValue)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                    />
                </LocalizationProvider>
            </div>
            {lastSegment === userReportType[1] ? (
                <div className="col-md-2 col-sm-6 col-12">
                    <Select
                        searchable={true}
                        multi={false}
                        options={activeListOptions}
                        onChange={(newValue) => handleFilterInputChange('filter', newValue)}
                        searchBy="name"
                        labelField="name"
                        values={filterInputs?.filter ? [filterInputs?.filter] : []}
                        name="filter"
                        valueField="value"
                        className="font-11"
                    />
                </div>
            ) : lastSegment === userReportType[2] ? (
                <div className="col-md-2 col-sm-6 col-12">
                    <Select
                        searchable={true}
                        multi={false}
                        options={weekListOptions}
                        onChange={(newValue) => handleFilterInputChange('filter', newValue)}
                        searchBy="name"
                        labelField="name"
                        values={filterInputs?.filter ? [filterInputs?.filter] : []}
                        name="filter"
                        valueField="value"
                        className="font-11"
                    />
                </div>
            ) : null}
            <div className="col-sm-4 col-12 d-flex">
                <button className={`${btnClass} bg-green-color`} onClick={search}>
                    <SearchIcon size={20} className="me-1" />
                    <span className="me-1">{t('buttonTitle.search')}</span>
                </button>
                <button className={`${btnClass} bg-blue-color`} onClick={reset}>
                    <RestartAltIcon size={20} className="me-1" />
                    <span className="me-1">{t('buttonTitle.reset')}</span>
                </button>
                <button className={`${btnClass} bg-blue-color`} onClick={() => getUserReport(true)}>
                    <DownloadingIcon size={20} className="me-1" />
                    <span className="me-1">{t('buttonTitle.download')}</span>
                </button>
            </div>
        </div>
    )
}
